import { render, staticRenderFns } from "./EmployerMatchTypeSelect.vue?vue&type=template&id=342ef074&"
import script from "./EmployerMatchTypeSelect.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports